import {NgModule} from '@angular/core';
import {KeeniconComponent} from './keenicon/keenicon.component';
import { CommonModule } from "@angular/common";
import { PaginationComponent } from './pagination/pagination.component';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { LicenseListModalComponent } from './license-list-modal/license-list-modal.component';
import { DividerModule } from 'primeng/divider';
import { ImageCropperModalComponent } from './image-cropper-modal/image-cropper-modal.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { CodeInputDirective } from 'src/app/services/code-input.directive';
import { CurrencyConvertPipe } from 'src/app/services/currency.pipe';
import { CarouselModule } from 'primeng/carousel';
import { CompanyListModalComponent } from './company-list-modal/company-list-modal.component';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { TableColumnDisplayComponent } from './table-column-display/table-column-display.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    KeeniconComponent,
    PaginationComponent,
    LicenseListModalComponent,
    ImageCropperModalComponent,
    CompanyListModalComponent,
    TableColumnDisplayComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    InputSwitchModule,
    DropdownModule,
    SelectButtonModule,
    CalendarModule,
    DividerModule,
    ImageCropperComponent,
    CodeInputDirective,
    CurrencyConvertPipe,
    CarouselModule,
    TableModule,
    TooltipModule,
    InputTextModule,
    ClipboardModule,
    NgbTooltipModule
  ],
  exports: [
    KeeniconComponent,
    PaginationComponent,
    LicenseListModalComponent,
    CodeInputDirective,
    CurrencyConvertPipe,
    TableColumnDisplayComponent
  ]
})
export class SharedModule {
}
